import { ApolloQueryResult, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { AlertBars } from "src/types/graphql.d";

interface AlertsData {
  alertBar: AlertBars;
}

interface AlertsVars {
  shop_type: string;
}

export const GET_ALERTS = gql`
  query alertBar($shop_type: String!) {
    alertBar(shop_type: $shop_type) {
      alert {
        content
        bg_color
        link
        text_color
        valid_till
        start_date
        end_date
      }
    }
  }
`;

function useAlerts(shop_type: string): {
  loading: boolean;
  error: any;
  data: AlertsData | undefined;
  refetch: () => Promise<ApolloQueryResult<AlertsData>>;
} {
  const { loading, error, data, refetch } = useQuery<AlertsData, AlertsVars>(
    GET_ALERTS,
    {
      variables: {
        shop_type,
      },
      skip: !shop_type,
      fetchPolicy: "cache-and-network",
    }
  );

  return { loading, error, data, refetch };
}

export { useAlerts };
